var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup2607(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4.999,
    height: 20,
    viewBox: "0 0 4.999 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2607",
    "data-name": "Group 2607",
    transform: "translate(322.852 -141.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3563",
    "data-name": "Path 3563",
    d: "M-320.354,146.019a2.5,2.5,0,0,1-2.5-2.511,2.5,2.5,0,0,1,2.5-2.488,2.5,2.5,0,0,1,2.5,2.51A2.5,2.5,0,0,1-320.354,146.019Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3564",
    "data-name": "Path 3564",
    d: "M-320.359,338.019a2.5,2.5,0,0,1-2.493-2.516,2.5,2.5,0,0,1,2.506-2.483,2.5,2.5,0,0,1,2.493,2.515A2.5,2.5,0,0,1-320.359,338.019Z",
    transform: "translate(0 -184.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3565",
    "data-name": "Path 3565",
    d: "M-320.341,525.019a2.5,2.5,0,0,1,2.488,2.5,2.5,2.5,0,0,1-2.511,2.5,2.5,2.5,0,0,1-2.488-2.521A2.5,2.5,0,0,1-320.341,525.019Z",
    transform: "translate(0 -368.998)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2607);
export default __webpack_public_path__ + "static/media/Group 2607.8c24486702efb7947316e49c094831ea.svg";
export { ForwardRef as ReactComponent };